import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisplayRelationPropertyComponent } from './display-relation-property.component';
import { SubscribeDirective } from '@ngneat/subscribe';
import { SkeletonModule } from '@tcc-mono/shared/ui/skeleton';

@NgModule({
  imports: [
    CommonModule,
    SkeletonModule,
    SubscribeDirective
  ],
  declarations: [DisplayRelationPropertyComponent],
  exports: [DisplayRelationPropertyComponent]
})
export class DisplayRelationPropertyModule { }
